import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=ff17e622&"
import script from "./AddBankAccount.vue?vue&type=script&lang=js&"
export * from "./AddBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddBankAccount.vue"
export default component.exports